import '../../../scss/app/blog_post_list.scss'
import $ from 'jquery'

const $filterButton = $('.blog-post-list-filter__button')

function closeDropdowns() {
  $filterButton.attr('aria-expanded', false)
  $filterButton.next().attr('hidden', true)
}

$filterButton.on('click', (ev) => {
  ev.stopImmediatePropagation()
  ev.stopPropagation()

  const state = $filterButton.attr('aria-expanded') === 'true' || false

  $filterButton.attr('aria-expanded', !state)
  $filterButton.next().attr('hidden', state)
})

$(document).on('click', closeDropdowns)
